import { ActivatedRoute,Router } from '@angular/router';
// import { FormControl ,FormGroup, Validators } from '@angular/forms';
// import {HttpErrorResponse} from '@angular/common/http';
// import { NgxSpinnerService } from 'ngx-spinner';
import { ServicesService } from '../services/services.service';
import {environment} from '../../environments/environment';
import swal from 'sweetalert2'; 
import { Component, OnInit, ViewChild,TemplateRef} from '@angular/core';

@Component({
  selector: 'app-construction',
  templateUrl: './construction.component.html',
  styleUrls: ['./construction.component.css']
})
export class ConstructionComponent implements OnInit {


    fields:any=[];
    listData:any=[];
    project_id:any;
    projectName:any='';
    maintenance_id:any;

    public loading = false;
    isLoader: boolean = false;
    public show:boolean = false;
    apiBaseUrl = environment.apiBaseUrl;
    spinLoader = {
        filter : false,
        delete : []
    };

    isListData=true;
    isOnePage=false;
    route: string;

    isShowQRCodeModal: boolean;
    qrCodeData: string = null;
    qrCodeFileName: string = null;

    constructor(private activeroute: ActivatedRoute,private _services: ServicesService, private router: Router) {
        this.activeroute.queryParams.subscribe(params => {
            this.project_id = params['project_id'],
            this.projectName = params['pname'],
            this.maintenance_id =params['maintenance_id']
        });
    }


    ngOnInit() {
        this.getPageRequest();
        

        if(this.maintenance_id){
            this.fields = [
                {
                    'field' : 'const_no',
                    'title' : 'Construction No',
                    'width' : '30%',
                    'code'  : true,
                    'sort'  : false
                },
                {
                    'field' : 'beneficiary_name',
                    'title' : 'Beneficiary Name',
                    'width' : '30%',
                    'code'  : true,
                    'sort'  : true
                },
                {
                    'field' : 'const_address',
                    'title' : 'Construction Address',
                    'width' : '35%',
                    'code'  : false,
                    'sort'  : false
                }
            ]
        }
        else{
            this.fields = [
                {
                    'field' : 'const_no',
                    'title' : 'Construction No',
                    'width' : '25%',
                    'code'  : true,
                    'sort'  : false
                },
                {
                    'field' : 'beneficiary_name',
                    'title' : 'Beneficiary Name',
                    'width' : '25%',
                    'code'  : true,
                    'sort'  : true
                },
                {
                    'field' : 'cont_name',
                    'title' : 'Under Contractor',
                    'width' : '22%',
                    'code'  : false,
                    'sort'  : false
                },
                {
                    'field' : 'const_address',
                    'title' : 'Construction Address',
                    'width' : '20%',
                    'code'  : false,
                    'sort'  : false
                }
            ]
        }

    }

    resetSearchField(){
        this.spinLoader['filter'] = true;
        this.searchFields=[''];
        this.getPageRequest();
    }

    getSearchRequest(){
        this.spinLoader['filter'] = true;
        this.getPageRequest();
    }

    status:any;

    deleteProject(id){
        this.status = confirm("Are You Sure");
        if(this.status){
            this.route = 'delete-project';
            let token = this._services.getToken();
            var data = {
                'id':id,
                page  : this.currentPage,
                search: {
                    'const_address' : this.searchFields['const_address'],
                },
                sort  : this.sortingData
            };
            this._services.postRequest(data,this.route,token).subscribe((data: any) => {
                swal({
                    title: 'Deleted.',
                    text: data.message,
                    type: 'success',
                    showCancelButton: false,
                    confirmButtonColor: 'rgb(17, 205, 239)',
                    cancelButtonColor: 'rgb(245, 54, 92)',
                    confirmButtonText: 'Yes'
                }).then(() => {
                    this.listData = data.result;
                    this.paginate = data.paginate;
                    this.getPages(this.paginate.last_page);
                })
            });
        }
    }

    sortType : string = '';
    sortField: string = '';
    oldField: string;
    sortingData= {
        'field' : '',
        'type'  : ''
    };

    sortBy(field, event){
        this.spinLoader['filter'] = true;
        this.oldField = (this.oldField != field) ? this.oldField : field;

        if(typeof this.oldField !== 'undefined'){
            ////console.log(document.getElementById('fa-'+this.oldField));
            document.getElementById('fa-'+this.oldField).classList.remove('fa-sort-up');
            document.getElementById('fa-'+this.oldField).classList.remove('fa-sort-down');
            document.getElementById('fa-'+this.oldField).classList.add('fa-sort');
        }

        event.target.classList.add('fa');

        this.sortField = field;
        this.sortType = (this.sortType == 'desc') ? 'asc' : 'desc';

        switch(this.sortType){
            case 'desc' : {
                event.target.classList.remove('fa-sort-up');
                event.target.classList.add('fa-sort-down');
                this.oldField = field;
            }break;
            case 'asc'  : {
                event.target.classList.remove('fa-sort-down');
                event.target.classList.add('fa-sort-up');
                this.oldField = field;
            }break;
            default     : {
                event.target.classList.add('fa-sort');
            }
        }

        this.sortingData = {
            'field' : this.sortField,
            'type'  : this.sortType
        };

        this.getPageRequest();
    }
    /*------------------------------Table with Sorting Ends Here--------------------------*/

    /*------------------------------Pagination Integration Starts Here------------------------*/
    currentPage: number = 1;
    loader: boolean = false;
    paginate= {
        'last_page' : 1
    };
    searchFields= [];
    pages: any;
//   listData = [];
    editData: Object = {};

    previousPage(){
        if(this.currentPage == 1){
            return;
        }

        this.currentPage = this.currentPage -1;
        ////console.log(this.currentPage);return;
        this.getPageRequest();

    }

    nextPage() {

        if (this.paginate.last_page-1 < this.currentPage) {
            return;
        }

        this.currentPage ++;
        //console.log(this.currentPage);
        this.getPageRequest();
    }

    changePage(){

        this.currentPage = this.currentPage;
        ////console.log(this.currentPage);return;
        this.getPageRequest();
    }

    getPages(n){
        if(n>1){
            this.isOnePage=true;
        }else{
            this.isOnePage=false;
        }
        var data = [];
        for (var i = 1; i <= n; i++) {
            data.push(i);
        }
        this.pages = data;
    }

    /*------------------------------Pagination Integration Starts Here------------------------*/
    routeData:string;
    totalData:any;
    getPageRequest(){
        /** bothe construction and maintainance results are saved in 2 different table hence different api based on presence of maintainance id in url */
        if(this.maintenance_id){
            this.routeData = 'get-maintenance-construction-list-web';
        }
        else{
            this.routeData = 'get-construction-list-web';
        }
        var  data;
        switch(this.routeData){ 

            case 'get-construction-list-web':{
                data = {
                    project_id:this.project_id,
                    page  : this.currentPage,
                    search: {
                        'beneficiary_name' : this.searchFields['beneficiary_name'],
                    },
                    sort  : this.sortingData,
                };
                break;
            }

            case 'get-maintenance-construction-list-web':{
                data = {
                      project_id:this.project_id,
                      maintenance_id:this.maintenance_id,
                      page  : this.currentPage,
                      search: {
                          'beneficiary_name' : this.searchFields['beneficiary_name'],
                      },
                      sort  : this.sortingData,
                  };
                  break;
              }
        }

        this.loading = true;
        const token = localStorage.getItem('userToken');
        this._services.requestCreator(data, this.routeData, token).subscribe((result: any) => {
            if(this._services.checkToken(result.status)){
                this.spinLoader['filter'] = false;
            this.isListData=false;
            // //console.log(result);
            this.listData = [];
            this.listData = result.result.result;
            this.paginate = result.result.paginate;
            this.totalData =result.result.paginate.total;
            this.currentPage = result.result.paginate.current_page;

            if(result.result.paginate.current_page > result.result.paginate.last_page){
                this.currentPage = result.result.paginate.last_page;
            }

            this.getPages(this.paginate.last_page);

            for (let key in this.spinLoader) {
                if(key == 'delete'){

                    this.spinLoader[key] = [];
                }else{
                    this.spinLoader[key] = false;
                }
            }
            }
        });

        return true;
    }





    // QR Code Generator =====================================================
    onGetQRCode(construction_id, event) {
   
        swal({
            title: 'QR Code Generated.',
            text: "Right click save as to save QR code ",
            imageUrl:'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data='+construction_id+'',
            showCancelButton: false,
            confirmButtonColor: 'rgb(17, 205, 239)',
            cancelButtonColor: 'rgb(245, 54, 92)',
            confirmButtonText: 'Exit'
        }).then(() => {
      

        })

    }



 
        // this.isShowQRCodeModal = true;
        // this.qrCodeData = construction_id;
        // this.isShowQRCodeModal = true;
        // const oldText = event.target.innerHTML;
        // event.target.innerHTML = '<i class="fa fa-spinner fa-spin" aria-hidden="true"></i>';
        // event.target.disabled = true;
    
    
    onDownloadQRCode(q) {
        const blob = q.el.nativeElement.children[1].currentSrc;
        const a: HTMLAnchorElement = document.createElement('a');
        document.body.appendChild(a);
        a.href = blob;
        a.download = this.qrCodeFileName + '.png';
        a.click();
    }

}


